<script setup lang="ts">
withDefaults(
  defineProps<{
    as?: string
    width?: 'default' | 'wide' | 'full'
    layout?: 'page' | 'wide' | 'workspace' | 'full'
  }>(),
  {
    as: 'main',
    layout: 'page',
    width: 'default',
  },
)
</script>
<template>
  <component
    :is="as"
    class="ui-page-shell"
    :class="[`ui-page-shell--${width}`, `ui-page-shell--${layout}`]"
    ><slot
  /></component>
</template>
